import dayjs from 'dayjs'

import { ClassifiedEmployeeBlock } from '../../rest/types/Classified'

export function BlockPaidEmploymentTransformer({
  block,
  t,
}: {
  block: ClassifiedEmployeeBlock
  t: any
}) {
  return {
    ...((block?.startDate || block?.endDate) && {
      adsReplacementDate: {
        title: t('ads_replacement_date_title'),
        subtitle: {
          label: t('ads_replacement_date_employee_subtitle'),
          requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
        },
        periods: {
          label: t('ads_replacement_date_period_label'),
          start: dayjs(block?.startDate).format('DD MMMM YYYY'),
          finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
        },
      },
    }),
    ...(block?.job?.length && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.job
            ? [
                {
                  title: t('ads_types_vacancy_title'),
                  texts: block?.job?.map((item) =>
                    t(`ads_details_vacancy_${item}`)
                  ),
                },
              ]
            : []),
        ],
      },
    }),
    adsDetails: {
      items: [
        ...(block?.contract?.length
          ? [
              {
                label: t('ads_details_contract_type_title'),
                values: block?.contract?.map((item) =>
                  t(`ads_details_contract_type_${item}`)
                ),
              },
            ]
          : []),
      ],
    },
  }
}
